var _path, _path2, _path3, _path4, _path5, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLightSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4896 16.282C34.6204 16.419 34.723 16.5801 34.7917 16.7562C34.8658 16.9342 34.9048 17.1248 34.9064 17.3174H21.1004L17.2736 17.2754C17.2736 17.2754 15.1594 17.3294 13.5465 17.3294H6.34295H0.000211203C-0.00316049 17.1369 0.0338705 16.9457 0.108944 16.7682C0.181861 16.59 0.290832 16.4286 0.429101 16.294L5.95333 10.8046L9.50526 7.27812L16.3917 0.432186C16.5278 0.294855 16.69 0.185705 16.8689 0.111048C17.0492 0.0380037 17.242 0.000295323 17.4367 0C17.6304 0.000681132 17.8222 0.0383823 18.0015 0.111048C18.1813 0.185639 18.3445 0.294772 18.4818 0.432186L25.4286 7.31714L29.0318 10.8797L34.4896 16.282Z",
    fill: "url(#paint0_linear_1424_4922)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5369 18.9395L18.4866 28.8568C18.1987 29.1443 17.834 29.2832 17.4426 29.2832C17.0512 29.2832 16.6758 29.1299 16.3987 28.8568L6.33623 18.9395H7.12441e-05C-0.00184955 19.1306 0.0350871 19.3201 0.108691 19.4969C0.181533 19.6739 0.29039 19.8342 0.428516 19.9679L16.4017 35.7099C16.5367 35.8482 16.6989 35.9577 16.8784 36.0318C17.058 36.1062 17.2508 36.1447 17.4456 36.1451C17.6405 36.1453 17.8334 36.1068 18.0129 36.0318C18.1923 35.9577 18.3545 35.8482 18.4896 35.7099L34.4778 19.9679C34.6159 19.8335 34.7256 19.6734 34.8007 19.4969C34.8733 19.3199 34.9092 19.1304 34.9063 18.9395H28.5369Z",
    fill: "url(#paint1_linear_1424_4922)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8552 29.1828C17.7977 29.9521 19.9457 31.7326 21.4142 32.8537C21.4075 32.8232 18.2087 36.1989 18.0223 36.2778C17.8427 36.3538 17.6497 36.3928 17.4548 36.3927C17.2599 36.3923 17.067 36.3532 16.8872 36.2778C16.7077 36.2026 16.5454 36.0915 16.4102 35.9512L0.42874 19.9827C0.290542 19.847 0.181628 19.6844 0.108748 19.5049C0.0351054 19.3256 -0.00185051 19.1333 7.12814e-05 18.9395H6.33954L16.11 28.5893C16.3292 28.7871 16.7456 29.1388 16.8552 29.1828Z",
    fill: "url(#paint2_linear_1424_4922)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.63,
    d: "M22.6133 31.666C22.5818 31.6974 21.4316 32.8477 21.4316 32.8477L19.1557 31.0533L16.9236 29.215L18.513 29.7693L20.9307 30.7515L22.8196 31.5071C22.8196 31.5071 22.7008 31.5785 22.6133 31.666Z",
    fill: "url(#paint3_linear_1424_4922)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1424_4922",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 18
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3403 16.1957C34.4706 16.3307 34.5727 16.4894 34.641 16.6629C34.7149 16.8384 34.7537 17.0261 34.7553 17.216H21.0091L17.1988 17.1746C17.1988 17.1746 15.0937 17.2278 13.4879 17.2278H6.31549H0.000210289C-0.00314681 17.0381 0.0337239 16.8497 0.108472 16.6748C0.181074 16.4992 0.289573 16.3402 0.427244 16.2075L5.92756 10.7986L9.46411 7.32379L16.3207 0.578195C16.4563 0.442877 16.6178 0.335327 16.7959 0.261764C16.9754 0.18979 17.1674 0.152635 17.3612 0.152344C17.5541 0.153015 17.745 0.190164 17.9236 0.261764C18.1026 0.335262 18.2651 0.442796 18.4017 0.578195L25.3185 7.36224L28.9062 10.8726L34.3403 16.1957Z",
    fill: "url(#paint4_linear_1424_4922)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1424_4922)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3472,
    height: 20.9914,
    transform: "matrix(0.728994 -0.68452 0.712595 0.701576 -1.05078 16.2773)",
    fill: "url(#paint5_linear_1424_4922)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1424_4922",
    x1: 13.2977,
    y1: 0.982213,
    x2: 31.128,
    y2: 18.8855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#343761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343761"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1424_4922",
    x1: 17.4532,
    y1: 18.9395,
    x2: 17.4532,
    y2: 36.1451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CC6F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5712F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1424_4922",
    x1: 9.09498,
    y1: 18.9395,
    x2: 9.09498,
    y2: 36.3927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4141F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC9FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1424_4922",
    x1: 19.0419,
    y1: 32.1115,
    x2: 20.4014,
    y2: 30.5662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F187C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4137CD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1424_4922",
    x1: 16.4081,
    y1: 4.84877,
    x2: 23.6968,
    y2: 16.7111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#343761"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1424_4922",
    x1: 9.13385,
    y1: 5.77346,
    x2: 19.1871,
    y2: 11.2218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5FA0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864583,
    stopColor: "#343761"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLightSmall);
export default __webpack_public_path__ + "static/media/logoLightSmall.4591d1aa50a48c0de30a34e7f472b2f9.svg";
export { ForwardRef as ReactComponent };